import { combineReducers } from '@reduxjs/toolkit';
import annotationReducer from './Components/AnnotationManager/Annotation/annotation.slice';
import annotationFormReducer from './Components/AnnotationManager/Annotation/AnnotationForm/AnnotationForm.slice';
import annotationCommentsReducer from './Components/AnnotationManager/Annotation/AnnotationForm/Comments/AnnotationComments.slice';
import annotationValidationReducer from './Components/AnnotationManager/Annotation/AnnotationValidationModal/AnnotationValidationModal.slice';
import stitchingViewReducer from './Components/AnnotationManager/StitchedView/stitchedView.slice';
import canvasReducer from './Components/AnnotationManager/Canvas/canvas.slice';
import findingTypePropertyTemplateReducer from './Components/AnnotationManager/FindingTypePropertyTemplate/findingTypePropertyTemplate.slice';
import annotationStandardsReducer from './Components/AnnotationManager/AnnotationStandards/annotationStandards.slice';
import annotationStandardFormReducer from './Components/AnnotationManager/AnnotationStandardForm/AnnotationStandardForm.slice';
import findingTypeTemplateReducer from './Components/AnnotationManager/FindingTypeTemplate/findingTypeTemplate.slice';
import failureMechanismTemplateReducer from './Components/AnnotationManager/FailureMechanismTemplate/failureMechanismTemplate.slice';
import failureModeCategoryTemplateReducer from './Components/AnnotationManager/FailureModeCategoryTemplate/failureModeCategoryTemplate.slice';
import eightDTemplateReducer from './Components/AnnotationManager/EightDTemplate/eightDTemplate.slice';
import homeReducer from './Components/AnnotationManager/Home/Home.slice';
import landingReducer from './Components/Shared/Landing/Landing.slice';
import maintenanceTriggerFormReducer from './Components/MaintenanceTriggers/MaintenanceTrigger/MaintenanceTriggerForm.slice';
import qcReducer from './Components/AnnotationManager/Annotation/Tree/QC/qc.slice';
import turbineStatusReducer from './Components/AnnotationManager/Annotation/Tree/TurbineStatus/turbineStatus.slice';

const rootReducer = combineReducers({
  annotation: annotationReducer,
  annotationForm: annotationFormReducer,
  annotationValidationModal: annotationValidationReducer,
  stitchingView: stitchingViewReducer,
  canvas: canvasReducer,
  findingTypePropertyTemplate: findingTypePropertyTemplateReducer,
  annotationStandards: annotationStandardsReducer,
  annotationStandardForm: annotationStandardFormReducer,
  findingTypeTemplate: findingTypeTemplateReducer,
  failureMechanismTemplate: failureMechanismTemplateReducer,
  failureModeCategoryTemplate: failureModeCategoryTemplateReducer,
  eightDTemplate: eightDTemplateReducer,
  home: homeReducer,
  landing: landingReducer,
  maintenanceTriggerForm: maintenanceTriggerFormReducer,
  qc: qcReducer,
  turbineStatus: turbineStatusReducer,
  annotationComments: annotationCommentsReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
